// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"81e9fabc","69":"efa4d6b3","70":"4985fa2e","200":"ebc016aa","394":"864b3758","453":"c33e1485","481":"9b3b75fa","695":"832c9ee5","739":"718a0c4b"}[chunkId] + ".chunk.js";
};